import React from "react";
import { PropTypes } from "prop-types";
import css from "../commonMagneticStyle.less";
import { getColor } from "../../utils/colors";
import { useI18n } from "../../i18n/useI18n";
import reactWrapper from "@harbor/elements/utils/react/wrapper";

const [
  HbrIcon,
  HbrTooltip,
  HbrTag,
  HbrIconButton
] = reactWrapper([
  "hbr-icon",
  "hbr-tooltip",
  "hbr-tag",
  "hbr-icon-button"
]);
const QoEScoreComponent = props => {
  const { tViews } = useI18n('views');
  const { appScoreChange, appScore, tooltipInfo, isReport = false } = props;
  return (
    <div className={`flex-items ${css["qoe-score"]}`}>
      <div className="flex-items">
        <HbrTag sentiment="info" id="negative">
          {appScore ? appScore : 0} {tViews('appExperienceOutOf10')}
        </HbrTag>
        <HbrIcon
            id="trendIcon"
            name="trend-up"
            style={{ color: getColor(appScoreChange, "changeQuality") }}
            label = {tViews('qualityOfExpTrendUp')}
          />
        <div className="hbr-type-h4">
          {appScoreChange}
        </div>
      </div>
      {!isReport && <HbrTooltip
          content={tooltipInfo}
          placement="top"
        >
        <HbrIconButton 
        noPadding={true}
          className="flex-items"
          name="info"
          sentiment="neutral"
          size="16px"
        />
      </HbrTooltip>}
    </div>
  );
};

QoEScoreComponent.propTypes = {
  appScoreChange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  appScore: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  tooltipInfo: PropTypes.string.isRequired,
  isReport: PropTypes.bool
};

export default QoEScoreComponent;